import alert from 'sweetalert2';




export function onlynumber(evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    //var regex = /^[0-9.,]+$/;
    var regex = /^[0-9.]+$/;
    if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
    }
}


export  function Alerta(wtitle,wtext,wicon){
    alert.fire({
      title:wtitle,
      text:wtext,
      icon:wicon
    })  
  }








